(() => {
  'use strict';

  if (window.__TorrasPdpAnalyticsInstalled) return;
  window.__TorrasPdpAnalyticsInstalled = true;

  const stickyAtcMedia = window.matchMedia('(min-width: 750px)');

  function analyticsTarget(event, selector) {
    const target = event?.target;
    return target && typeof target.closest === 'function' ? target.closest(selector) : null;
  }

  function trackInteraction(target, interactionName) {
    if (!target || !interactionName) return;
    window.TorrasAnalytics?.trackInteraction(target, {
      elementType: target.dataset.analyticsElementType,
      elementId: target.dataset.analyticsElementId,
      elementPosition: target.dataset.analyticsElementPosition,
      interactionName,
    });
  }

  function registerDetails(scope) {
    const detailsElements = [];
    if (scope?.matches?.('[data-pdp-analytics-details]')) detailsElements.push(scope);
    if (typeof scope?.querySelectorAll === 'function') {
      detailsElements.push(...scope.querySelectorAll('[data-pdp-analytics-details]'));
    }

    detailsElements.forEach((details) => {
      details.dataset.pdpAnalyticsOpenState = String(details.open);
    });
  }

  document.addEventListener('click', (event) => {
    const interactionTarget = analyticsTarget(
      event,
      '[data-pdp-analytics-interaction], [data-pdp-analytics-toggle]'
    );
    if (interactionTarget) {
      const interactionName = interactionTarget.dataset.pdpAnalyticsInteraction ||
        (interactionTarget.getAttribute('aria-expanded') === 'true' ? 'expand' : 'collapse');
      trackInteraction(interactionTarget, interactionName);
    }

    const stickyAtc = analyticsTarget(event, '[data-analytics-sticky-atc="true"]');
    if (!stickyAtc || !stickyAtcMedia.matches) return;

    window.TorrasAnalytics?.trackClick(stickyAtc, {
      componentId: 'pdp_sticky_atc',
      componentType: 'add_to_cart',
      elementType: 'cta',
      elementId: 'add_to_cart',
      elementPosition: 1,
    });
  });

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!details?.matches?.('[data-pdp-analytics-details]')) return;

      const currentState = String(details.open);
      const previousState = details.dataset.pdpAnalyticsOpenState;
      details.dataset.pdpAnalyticsOpenState = currentState;
      if (previousState === undefined || previousState === currentState) return;

      trackInteraction(details, details.open ? 'expand' : 'collapse');
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => registerDetails(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => registerDetails(document), { once: true });
  } else {
    registerDetails(document);
  }
})();
